export const OLD_FORMAT_EXTS = ['doc', 'xls'];
